module.exports = __webpack_public_path__ + "img/tip_icon.679cc40b.svg";